export const GuestDetailsDrawerTestIdFactory = {
    getDrawerTestId: () => 'guest-details',
    getGuestAvatarTestId: () => 'guest-details-avatar',
    getGuestEmailTestId: () => 'guest-details-email',
    getLoadingTestId: () => 'loading-guest-data',
    getLoadErrorTestId: () => 'guest-load-error',
    getRetryTestId: () => 'retry-load-guest',
    getGuestLinkEntryTestId: (linkId) => ['guest-link-entry', linkId].join('-'),
    getOpenGuestLinkTestId: () => 'open-guest-link',
    getRemoveFromLinkTestId: () => 'remove-guest-from-link',
    getCreatorAvatarTestId: () => 'guest-link-created-by-avatar',
    getDeactivatedCreatorTestId: () => 'deactivated-guest-link-creator',
    getMissingCreatorTestId: () => 'missing-guest-link-creator',
    getDeletedEntryTestId: () => 'deleted-entry',
    getFailedPathTestId: () => 'failed-to-fetch-path',
    getRemoveFromAllLinksTestId: () => 'remove-guest-from-all-links',
    getCloseTestId: () => 'guest-details-close',
};
